import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { applyDevExtremeLicense } from './app/core/devextreme-license';
import { initDevExtremeThemeSync } from './app/core/devextreme-theme';
import { readStoredAccent, readStoredTheme } from './app/core/theme.service';

if (environment.production) {
  enableProdMode();
}

// --- Tema persistido ANTES del render (evita parpadeo) ---
// Base Fluent light/dark + acento (lista y default definidos en theme.service.ts).
// Default: claro blanco. Si hay una elección guardada del usuario, se respeta.
const persistedTheme = readStoredTheme();
const persistedAccent = readStoredAccent();
document.documentElement.setAttribute('data-theme', persistedTheme);
document.documentElement.setAttribute('data-accent', persistedAccent);

// --- Licencia DevExtreme (runtime key compartida con el DAM) — Tarea 8.2 / Req 8.2 ---
applyDevExtremeLicense();

// --- Sincroniza el tema DevExtreme con data-theme/data-accent — Tarea 8.4 / Req 8.3 ---
initDevExtremeThemeSync();

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
